var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.00014 0C3.58884 0 0 3.58878 0 8C0 12.4112 3.58884 16 8.00014 16C12.4112 16 16 12.4112 16 8C16 3.58878 12.4114 0 8.00014 0ZM8.00014 14.84C4.2286 14.84 1.16003 11.7715 1.16003 8C1.16003 4.22852 4.2286 1.16001 8.00014 1.16001C11.7717 1.16001 14.84 4.22852 14.84 8C14.84 11.7715 11.7717 14.84 8.00014 14.84Z",
    fill: "#99BF5F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.38093 9.30066L5.15193 7.0717L4.33179 7.89183L7.38093 10.9412L11.7244 6.59784L10.9039 5.77771L7.38093 9.30066Z",
    fill: "#99BF5F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheck);
export default __webpack_public_path__ + "static/media/check.6776d036b6fee048c037d7c1b93fbbf1.svg";
export { ForwardRef as ReactComponent };